import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@bcc/components/ui/card";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { setConnectServiceStepTestId } from "./connect-service-step.utils";
import { ServiceTile } from "./service-tile";
import { ShopDomainModal } from "./shop-domain-modal";

type Platform = "shopify" | "woocommerce" | null;

export interface ConnectServiceStepProps {
  testId?: string;
}

export function ConnectServiceStep({ testId }: ConnectServiceStepProps = {}) {
  const { t } = useTranslation();
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTileClick = (platform: "shopify" | "woocommerce") => {
    setSelectedPlatform(platform);
    setIsModalOpen(true);
  };

  return (
    <div
      data-testid={testId ?? setConnectServiceStepTestId("container")}
      className="flex flex-col items-center gap-8"
    >
      <Card className="w-full max-w-3xl border-border-subtle shadow-sm">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-semibold text-text-primary">
            {t("onboarding.connectService.title")}
          </CardTitle>
          <CardDescription className="text-base text-text-muted">
            {t("onboarding.connectService.description")}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-6 md:flex-row">
          <ServiceTile
            platform="shopify"
            label={t("onboarding.connectService.shopify.label")}
            description={t("onboarding.connectService.shopify.description")}
            onClick={() => handleTileClick("shopify")}
          />
          <ServiceTile
            platform="woocommerce"
            label={t("onboarding.connectService.woocommerce.label")}
            description={t("onboarding.connectService.woocommerce.description")}
            onClick={() => handleTileClick("woocommerce")}
          />
        </CardContent>
      </Card>

      <ShopDomainModal
        platform={selectedPlatform}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
